import { Onix } from './Onix';

export class ProductRelationship {
  tipologia: Onix;
  ean13: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/ProductRelationship.ts